<template>
    <v-app pb-3>
        <v-content>
            <v-form ref="form">
                <v-container style="max-width: 1200px; padding-top: 100px">
                    <a class="py-4" href="/dashboard">Личный кабинет</a>
                    <v-layout pt-4 pb-5 row wrap>
                        <v-flex xs12 sm6>
                            <h1 class="py-4">Банковские продукты</h1>
                        </v-flex>
                        <v-flex xs12 sm6
                        style="text-align: right; padding-top: 40px"
                        v-if="showCommissions"
                        >
                            <!-- <span style="font-size: 18px; display: block">Общее вознаграждение:
                                <span
                                    style="padding-left: 20px; font-size: 40px; font-weight: 700">
                                    {{ this.commissionByMonth + '\xa0₽' }}
                                </span>
                            </span>
                            <osago-month
                                :value="commissionByMonth"
                                @change="balanceDateChanged"
                            /> -->
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container style="max-width: 1800px;">
                    <v-layout pb-4 row wrap>
                        <v-flex xs12 sm6 md8>
                            <v-text-field
                                py-5
                                v-model="filters.search"
                                prepend-inner-icon="search"
                                label="Поиск в таблице по ФИО, телефону, e-mail, order ID"
                                single-line
                                hide-details
                                @keydown.enter="newSearch"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm3 md2 pt-4>
                            <button @click.prevent.stop="newSearch" class="submit-button block">Поиск</button>
                        </v-flex>
                        <v-flex xs12 sm3 md2 pt-4>
                            <div class="activator-wrapper">
<!--                                <v-btn class="submit-button block"
                                    href="/bp/new"
                                    target="_blank"
                                    >Новая заявка
                                </v-btn>-->
                                <b2b-bank-products-type-dialog
                                    :links="productsList"
                                    :toDisplay="toDisplay"
                                    @changeDialog="changeDialog"
                                >
                                </b2b-bank-products-type-dialog>
                                <a href="/list" class="policy-link">Страховые продукты</a>
                            </div>
                        </v-flex>
                    </v-layout>

                    <h3 class="py-0">Фильтры</h3>
                     <v-layout py-0 row wrap class="filters">
                        <v-flex xs12 sm6 py0 v-if="showCurators">
                            <v-autocomplete
                                v-model="filters.curator"
                                :items="curatorsList"
                                :loading="isLoadingCuratorsFilter"
                                label="Куратор"
                                :search-input.sync="filters.curatorSearch"
                                item-value="id"
                                item-text="name"
                                multiple
                                chips
                                deletable-chips
                                :allow-overflow=false
                            >
                                <template v-slot:no-data>
                                    <v-list-tile>
                                        <v-list-tile-content>
                                            <v-list-tile-title>
                                                Не найдено: "<strong>{{ filters.curatorSearch }}</strong>".
                                            </v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>
                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 py0 v-if="showAgents">
                            <v-autocomplete
                                v-model="filters.agent"
                                :items="agentsList"
                                :loading="isLoadingAgentsFilter"
                                label="Пользователь"
                                :search-input.sync="filters.agentSearch"
                                item-value="id"
                                item-text="name"
                                multiple
                                chips
                                deletable-chips
                                :allow-overflow=false
                            >
                                <template v-slot:no-data>
                                    <v-list-tile>
                                        <v-list-tile-content>
                                            <v-list-tile-title>
                                                Не найдено: "<strong>{{ filters.agentSearch }}</strong>".
                                            </v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>
                            </v-autocomplete>
                        </v-flex>
                    </v-layout>

                    <v-layout py-0 row wrap class="filters date-filters-container">
                        <v-flex xs6 sm3 md3 lg2 py0 class="date-filter">
                            <osago-date
                                label="Изменен, от"
                                v-model="filters.date_from"
                                :max="currentDate"
                                :yearStarting="false"
                                :isRequired="false"
                            />
                        </v-flex>
                        <v-flex xs6 sm3 md3 lg2 py0 class="date-filter">
                            <osago-date
                                label="Изменен, до"
                                v-model="filters.date_to"
                                :min="minDateTo"
                                :yearStarting="false"
                                :isRequired="false"
                            />
                        </v-flex>
                        <v-flex xs6 sm3 md3 lg2 py0 class="type-filter">
                            <v-select
                                v-model="filters.product_type"
                                :items="typesList"
                                label="Тип заявки"
                                item-value='id'
                                item-text='name'
                                :menu-props="{ bottom: true, offsetY: true }"
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 sm6 md6 py0 class="operator-filter" v-if="showOperators">
                            <v-autocomplete
                                v-model="filters.operator"
                                :items="operatorsList"
                                :loading="isLoadingOperatorsFilter"
                                label="Сотрудник"
                                :search-input.sync="filters.operatorSearch"
                                item-value="id"
                                item-text="name"
                                multiple
                                chips
                                deletable-chips
                                :allow-overflow=false
                            >
                                <template v-slot:no-data>
                                    <v-list-tile>
                                        <v-list-tile-content>
                                            <v-list-tile-title>
                                                Не найдено: "<strong>{{ filters.operatorSearch }}</strong>".
                                            </v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>
                            </v-autocomplete>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap row>
                        <v-flex xs6 sm4 md5 lg7 class="clean-filters-field">
                            <a @click="cleanFilters" class="link">Очистить все</a>
                        </v-flex>
                        <v-flex xs12 sm4 md4 lg3 py0 class="status-filter-field">
                            <v-select
                                v-model="filters.status"
                                :items="statusList"
                                label="Статус"
                                item-value='id'
                                item-text='name'
                            />
                        </v-flex>
                        <v-flex xs6 sm4 md3 lg2 class="align-self-end">
                            <div class="links_container">
                                <a class="link" @click="downloadExport">Выгрузить результат</a>
                                <a
                                    v-if="role === 'admin'"
                                    class="link" @click="downloadReconciliationFile"
                                >
                                    Сверка статусов
                                </a>
                            </div>
                            <v-menu
                                    class="d-inline-block"
                                    d-inline
                                    :close-on-content-click="false"
                                    offset-x
                            >
                                <v-list>
                                    <v-list-tile
                                            v-for="(item) in toggleableColumns"
                                            :key="item.id"
                                    >
                                        <v-list-tile-action>
                                            <v-checkbox
                                                    class="mh-0-important"
                                                    :input-value="shownToggleableColumns[item.id]"
                                                    @change="toggleColumn($event, item.id)"
                                            />
                                        </v-list-tile-action>
                                        <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                        </v-flex>
                    </v-layout>

                    <v-tabs
                        v-model="tab"
                        slider-color="#000"
                        show-arrows
                    >
                        <v-tab v-for="(tab, index) in tabsList" :key="index"
                               :class="[index === 4 && prolongCount ? 'with-count' : '']"
                               @click="changeTab(index)"
                        >
                            {{ tab }}
                        </v-tab>
                    </v-tabs>

                    <v-data-table
                        :menu-props="{ left: false, offsetY: true }"
                        py-5
                        v-model="selected"
                        :headers="activeHeaders"
                        :items="rows"
                        :pagination.sync="pagination"
                        :total-items="totalRows"
                        :loading="loading"
                        item-key="1"
                        :rows-per-page-items="[10,25,50]"
                        :rows-per-page="10"
                        rows-per-page-text="Показывать по"
                        select-all
                        no-data-text="Нет данных"
                        no-results-text="Ничего не найдено"

                    >
                        <template v-slot:no-results>
                            <v-layout py-5>
                                <p>Ничего не найдено. <a @click="cleanFilters">Очистить фильтры</a></p>
                            </v-layout>
                        </template>
                        <template v-slot:headers="props">
                            <tr>
                                <th v-if="!isTermination" style="width: 50px">
                                    <v-checkbox
                                        :input-value="props.all"
                                        :indeterminate="props.indeterminate"
                                        primary
                                        hide-details
                                        @click.stop="toggleAll"
                                    ></v-checkbox>
                                </th>
                                <th
                                    v-for="header in props.headers"
                                    v-if="!header.toggleable || (header.toggleable && shownToggleableColumns[header.value])"
                                    :key="header.text"
                                    :class="[
                                        'column text-xs-center',
                                        pagination.descending ? 'desc' : 'asc',
                                        header.sortable === false ? '' : 'sortable',
                                        header.value === pagination.sortBy ? 'active' : ''
                                    ]"
                                    :style="{
                                        width: header.width + 'px',
                                        minWidth: header.width + 'px',
                                        maxWidth: header.maxWidth ? header.maxWidth + 'px' : 'none',
                                        paddingLeft: '10px',
                                        paddingRight: '10px',
                                    }"
                                    @click="header.sortable !== false && changeSort(header.value)"
                                >
                                    {{ header.text }}
                                    <v-icon v-if="header.sortable !== false" small>arrow_upward</v-icon>
                                </th>
                            </tr>
                        </template>
                        <template v-slot:items="props">
                            <tr :active="props.selected" @click="rowClicked(props.item)">
                                <td @click.stop style="width: 50px">
                                    <v-checkbox
                                        v-model="selected[props.item.order_uuid]"
                                        primary
                                        hide-details
                                    ></v-checkbox>
                                </td>
                                <template v-if="showCurators">
                                    <td style="width: 150px">{{ props.item['curator_name'] || '—' }}<br>{{ props.item['curator_email'] }}
                                    </td>
                                </template>
                                <template v-if="showAgents">
                                    <td style="width: 150px">{{ props.item['agent_name'] || '—' }}<br>{{ props.item['agent_email'] || '—' }}
                                    </td>
                                </template>
                                <template v-if="showOperators">
                                    <td style="width: 150px">{{ props.item['operator_name'] || '—'}}<br>{{ props.item['operator_email'] || '—' }}
                                    </td>
                                </template>
                                <template v-if="showOperators">
                                    <td style="width: 200px">{{ props.item['client_name'] || '—'}}<br>{{ props.item['client_phone'] || '—' }}
                                    </td>
                                </template>

                                <td style="width: 150px">{{ props.item['order_product'] || '—' }}</td>

                                <td style="width: 150px" v-if="props.item['created_at_formatted']">
                                    {{ props.item['created_at_formatted'].slice(0, 10) }}<br>в
                                    {{ props.item['created_at_formatted'].slice(11, 16) }}
                                </td>
                                <td style="width: 150px" v-else>—</td>

                                <td style="width: 150px">{{ props.item['sign_date_formatted'].slice(0, 10) }}<br>в
                                    {{ props.item['sign_date_formatted'].slice(11, 16) }}
                                </td>
                                <!-- Лого компании  -->
                                <td class="ins-logo-container" style="width: 250px">
                                    <img
                                         class="ins-logo"
                                         :alt="props.item['product_name']"
                                         :src="props.item['product_logo']"
                                    />
                                    <span class="ins-logo-name">
                                        {{ props.item['product_logo'] ? props.item['product_name'].split(' ').slice(0, 2).join(' ') : '—' }}
                                    </span>
                                </td>
                                <template> <!-- Статус -->
                                    <td style="width: 150px">{{ props.item['order_status_text_name'] || '—' }}</td>
                                </template>
                                <template v-if="showCommissions">
                                    <td class="text-md-center no-wrap" style="width: 150px">
                                        {{
                                            props.item['commission_format']
                                            && (props.item['order_status'] === 'Payed' || props.item['order_status'] === 'Issued')
                                            ? props.item['commission_format'] : '—'
                                        }}
                                    </td>
                                </template>
                                <td class="text-md-center wrap" style="width: 150px">
                                    {{
                                        props.item['order_uuid'] ? props.item['order_uuid'] : '—'
                                    }}
                                </td>
                                <td class="text-xs-right px-0" style="width: 100px" @click.stop="">
                                    <v-menu>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on">
                                                <v-icon>more_vert</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-tile
                                            v-if="props.item['order_status_text_name'] !== 'Черновик'"
                                                :href="'/bp/order/' + props.item['order_uuid']"
                                                target="_blank"

                                            >
                                                <v-list-tile-title>Просмотр</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile
                                                :href="'/bp/orders/' + props.item['order_uuid'] + '/edit'"
                                                target="_blank"
                                                v-if="props.item['order_status']!==1000 && props.item['order_status_text_name'] === 'Черновик'"
                                            >
                                                <v-list-tile-title>Редактировать</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile
                                                :href="'/bp/orders/' + props.item['order_uuid'] + '/copy'"
                                                target="_blank"
                                            >
                                                <v-list-tile-title>Создать новый расчет</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile
                                                v-if="role === 'admin' && props.item['order_status_text_name'] !== 'Черновик'"
                                                @click="changeStatus(props.item['order_uuid'])">
                                                <v-list-tile-title>Изменить статус</v-list-tile-title>
                                            </v-list-tile>
                                        </v-list>

                                    </v-menu>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-container>
            </v-form>

        </v-content>
        <div v-if="statusDialog" class="custom-modal">
            <div class="modal-overlay" @click="statusDialog = false"></div>

            <div class="modal-content">
            <h3 class="modal-title">Изменение статуса заявки</h3>

            <div class="modal-body">
                <label class="select-label">Новый статус:</label>
                <div class="custom-select">
                <select v-model="newStatus" class="status-select">
                    <option v-for="option in statusOptions" :key="option.id" :value="option.id">
                    {{ option.name }}
                    </option>
                </select>
                <div class="select-arrow">▼</div>
                </div>
            </div>

            <div class="modal-actions">
                <button class="modal-btn cancel-btn" @click="statusDialog = false">Отмена</button>
                <button class="modal-btn confirm-btn" @click="confirmStatusChange">Подтвердить</button>
            </div>
            </div>
        </div>
        <!-- <b2b-policy-type-dialog
            :links="policyTypesArray"
            :hideButton="true"
            :toDisplay="toDisplay"
            @changeDialog="changeDialog"
        >
        </b2b-policy-type-dialog> -->
    </v-app>
</template>

<script>
import _ from 'lodash'
import BankProductsTypeDialogButton from "../elements/BankProductsTypeDialogButton.vue";

export default {
    components: {
        'b2b-bank-products-type-dialog': BankProductsTypeDialogButton,
    },
    name: 'BankProductsList',
    props:
        [   'role',
            'showcommissions',
            'list',
            'total',
            'errors',
            'policyTypes',
        ],
    data: () => ({
         filters: {
            tab: 0,
            search: '',
            curatorSearch: '',
            agentSearch: '',
            operatorSearch: '',
            date_from: null,
            date_to: null,
            curator: [],
            agent: [],
            operator: [],
            product_type: null,
            status: null,
        },
        companiesList: [],

        // toDisplay: false,
        // policyTypesArray: [],

        pagination: {
            descending: true,
            sortBy: 'sign_date_formatted',
            page: 1,
            rowsPerPage: 10,
            totalItems: 0
        },

        tabsList: ['Все','Черновик', 'Ожидает подтверждения'],
        curatorsList: [],
        agentsList: [],
        operatorsList: [],
        typesList: [
            {id: null, name: 'Любой'},
            {id: 'debit', name: 'Дебетовые карты'},
            {id: 'credit', name: 'Кредитные карты'},
            {id: 'microcredit', name: 'Микрозаймы'},
            {id: 'mortgage', name: 'Ипотека'},
        ],
        statusList: [
            { id: null, name: 'Любой' },
            { id: 'waiting_approval', name: 'Ожидает подтверждения' },
            { id: 'waiting_commission_payment', name: 'Заявка заведена' },
            { id: 'canceled', name: 'Отклонено' },
            { id: 'payed', name: 'Продано' },
            /*{ id: 'issued', name: 'Оформлен' },*/
        ],
        productsList: [
            {
                name: 'Кредитные/Дебетовые карты',
                link: '/bp/new?productType=cards',
            },
            {
                name: 'Микрозаймы',
                link: '/bp/new?productType=microloans',
            },
            {
                name: 'Ипотека',
                link: '/bp/new?productType=mortgage',
            },
        ],
        statusDialog: false,
        selectedOrder: null,
        newStatus: null,
        statusOptions: [
            { id: 'WaitingApproval', name: 'Ожидает подтверждения' },
            { id: 'WaitingCommissionPayment', name: 'Заявка заведена' },
            { id: 'Canceled', name: 'Отклонено' },
            { id: 'Payed', name: 'Продано' },
            /*{ id: 'Issued', name: 'Оформлен' },*/
        ],

        headers: [
            {text: 'Куратор', value: 'curator_name', sortable: false, width: 150, align: 'center'},
            {text: 'Пользователь', value: 'agent_name', sortable: false, width: 150, align: 'center'},
            {text: 'Сотрудник', value: 'operator_name', sortable: false, width: 150, align: 'center'},
            {text: 'Заемщик', value: 'borrower_name', sortable: false, width: 200, align: 'center'},
            {text: 'Тип заявки', value: 'order_product', sortable: false, width: 150, align: 'center'},
            {text: 'Создан', value: 'created_at_formatted', width: 150, align: 'center'},
            {text: 'Изменен', value: 'sign_date_formatted', width: 150, align: 'center'},
            {text: 'Оффер', value: 'comp_name', sortable: false, width: 250, align: 'center'},
            {text: 'Статус', value: 'order_status_text_name', sortable: false, width: 150, align: 'center'},
            {text: 'Вознаграждение', value: 'commission_format', sortable: false, width: 150, align: 'center'},
            {text: 'Order ID', value: 'order_uuid', sortable: false, width: 150, align: 'center'},
        ],
        headersTermination: [],
        isTermination: false,
        isTerminationShow: false,
        rows: [],
        totalRows: 0,
        selected: [],
        tab: 0,
        toggleableColumns: [],
        shownToggleableColumns: {},


        showCurators: true,
        showAgents: true,
        showOperators: true,
        showCommissions: false,

        loading: false,
        init: false,

        isLoadingOperatorsFilter: false,
        isLoadingAgentsFilter: false,
        isLoadingCuratorsFilter: false,
        monthCommission: 0,
        commissionByMonth: '',

        currentDate: null,

        toDisplay: false,
        menuX: 0,
        menuY: 0,

        activeHeaders: [],
    }),
    computed: {
        minDateTo() {
            return this.filters.date_from || this.currentDate;
        },
    },
    methods: {
        changeDialog(value) {
            this.toDisplay = value
        },
        downloadReconciliationFile() {
        window.open('/bp/load-file', '_blank');
        },
    // form methods
        rowClicked(item) {
            let link = document.createElement('a');
            link.id = 'my_link';
            link.style.cssText = 'display: none';
            link.href = '/bp/order/' + item['order_uuid'];
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            link = undefined;
        },

        getCurrentDate() {
            const date = new Date();
            this.currentDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().slice(0,10);
        },
         toggleAll() {
            if (this.selected.length) {
                this.selected = [];
            } else {
                this.selected = this.$refs.policyListTable.filteredItems.slice();
            }
        },
        cleanFilters() {
            this.filters.search = '';
            this.filters.curatorSearch = '';
            this.filters.agentSearch = '';
            this.filters.operatorSearch = '';
            this.filters.product_type = null;
            this.filters.status = null;

            this.filters.date_from = null;
            this.filters.date_to = null;

            this.filters.agent = [];
            this.filters.curator = [];
            this.filters.operator = [];
            this.newSearch();
        },
        toggleColumn(event, index) {
            this.shownToggleableColumns[index] = event;
        },
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending;
            } else {
                this.pagination.sortBy = column;
                this.pagination.descending = false;
            }
        },
        changeTab(index) {
            this.filters.tab = index;
            this.pagination.page = 1;
            if (index !== undefined) {
                this.activeHeaders = this.headers
                this.pagination.sortBy = 'sign_date_formatted'
            }
        },
        paginationHandle() {
            if (!this.init) {
                return;
            }
            this.newSearch();
        },

        // async methods

        async downloadItems() {
            if (this.loading) return;

            const data = {
                p: this.pagination.page,
                i: -1,
                s: this.pagination.sortBy,
                desc: this.pagination.descending,
                f: JSON.stringify(this.filters),
            };

            this.loading = true;
            let result = [];

            try {
                const response = await axios.post('/bp/list', data);

                if (response.data && response.data.status === 'success') {
                    result = JSON.parse(window.atob(response.data));
                } else {
                    PNotify.error('Возникли ошибки при формировании файла');
                }
            } catch (error) {
                console.error('Ошибка запроса:', error);
                PNotify.error('Возникли ошибки при формировании файла');
            } finally {
                this.loading = false;
            }

            return result;
        },
        changeStatus(orderUuid) {
            this.selectedOrder = orderUuid;
            this.newStatus = null;
            this.statusDialog = true;
        },

        async confirmStatusChange() {
            if (!this.newStatus) {
                PNotify.error('Выберите новый статус');
                return;
            }

            try {
                const response = await axios.put(`/bp/orders/${this.selectedOrder}`, {
                    status: this.newStatus
                });

                if (response.status === 200) {
                    PNotify.success('Статус успешно обновлён');
                    const index = this.rows.findIndex(row => row.order_uuid === this.selectedOrder);
                    if (index !== -1) {
                        const statusText = this.statusOptions.find(s => s.id === this.newStatus).name;
                        Vue.set(this.rows[index], 'order_status_text_name', statusText);
                    }
                } else {
                    PNotify.error('Ошибка при обновлении статуса');
                }
            } catch (error) {
                console.error('Status update error:', error);
                PNotify.error('Ошибка при обновлении статуса');
            } finally {
                this.statusDialog = false;
            }
        },

        async newSearch() {
            if (this.loading) return;

            const data = {
                p: this.pagination.page,
                i: this.pagination.rowsPerPage,
                s: this.pagination.sortBy,
                desc: this.pagination.descending,
                f: JSON.stringify(this.filters),
            };
            this.loading = true;

            try {
                const response = await axios.post('/bp/list', data);

                if (response.data && response.data.status === 'success') {
                    this.rows = JSON.parse(window.atob(response.data.list));
                    for (let i = 0; i < this.rows.length; i++) {
                        Vue.set(this.rows[i], this.rows[i].length, false);
                    }

                    this.totalRows = response.data.total;
                } else {
                    PNotify.error('Возникли ошибки при поиске');
                    console.error('Ошибка ответа:', response);
                }
            } catch (error) {
                PNotify.error('Возникли ошибки при поиске');
                console.error('Ошибка запроса:', error);
            } finally {
                this.loading = false;
            }
        },

        async balanceDateChanged(val) {
            try {
                const response = await axios.get(`/accounting-balance?month=${val}`);

                if (response.data && response.data.status === 'ok') {
                    this.commissionByMonth = response.data.sum;
                } else {
                    PNotify.alert('Не удалось получить баланс');
                }
            } catch (error) {
                console.error('Request failed:', error);
                PNotify.alert('Не удалось получить баланс');
            }
        },

        async searchOperatorsFilter() {
            if (this.isLoadingOperatorsFilter || this.operatorsList.length > 0) {
                return;
            }
            this.isLoadingOperatorsFilter = true;
            axios.get('/policy-operators').then(response => {
                this.operatorsList = JSON.parse(window.atob(response.data.data));
                this.operatorsList.sort(this.sortByName);
            }).catch(error => {
                console.error(error);
                PNotify.alert('Не удалось получить список сотрудников');
            }).finally(() => {
                this.isLoadingOperatorsFilter = false;
            })
        },

         async searchAgentsFilter() {
            if (this.isLoadingAgentsFilter || this.agentsList.length > 0) {
                return;
            }
            this.isLoadingAgentsFilter = true;
            axios.get('/policy-agents').then(response => {
                this.agentsList = JSON.parse(window.atob(response.data.data));
                this.agentsList.sort(this.sortByName);
            }).catch(error => {
                console.error(error);
                PNotify.alert('Не удалось получить список пользователей');
            }).finally(() => {
                this.isLoadingAgentsFilter = false;
            })
        },

        async searchCuratorsFilter() {
            if (this.isLoadingCuratorsFilter || this.curatorsList.length > 0) {
                return;
            }
            this.isLoadingCuratorsFilter = true;
            axios.get('/policy-curators').then(response => {
                this.curatorsList = JSON.parse(window.atob(response.data.data));
                this.curatorsList.sort(this.sortByName);
            }).catch(error => {
                console.error(error);
                PNotify.alert('Не удалось получить список кураторов');
            }).finally(() => {
                this.isLoadingCuratorsFilter = false;
            })
        },

        async downloadExport() {
            if (this.loading) {
                return;
            }
            const data = {
                s: this.pagination.sortBy,
                desc: this.pagination.descending,
                p: this.pagination.page,
                i: -1,
                f: JSON.stringify(this.filters),
            };
            this.loading = true;
            await axios.post('/bp/list/export', data, {
                responseType: 'blob'
            }).then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'bank-products-export.xlsx');
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            })
                .catch(error => {
                    console.error(error);
                    PNotify.error('Возникли ошибки при формировании файла');
                    this.loading = false;
                });
            this.loading = false;
        },

    },
    created() {

        // this.policyTypesArray = JSON.parse(window.atob(this.policyTypes));

        this.getCurrentDate();

        if (this.role === 'admin') {
            this.showCurators = true;
            this.showAgents = true;
            this.showOperators = true;
            this.showCommissions = true;
        } else if (this.role === 'curator') {
            this.showAgents = true;
            this.showOperators = true;
            this.showCommissions = true;
        } else if (this.role === 'agent') {
            this.showOperators = true;
            this.showCommissions = true;
        } else if (this.role === 'operator') {
            this.showCommissions = this.showcommissions;
        }

        this.rows = JSON.parse(window.atob(this.list));

        for (let i = 0; i < this.rows.length; i++) {
            Vue.set(this.rows[i], this.rows[i].length, false);
        }
        this.totalRows = this.total;

        this.searchOperatorsFilter();
        this.searchAgentsFilter();
        this.searchCuratorsFilter();

        this.init = true;
        this.activeHeaders = this.headers
        this.pagination.sortBy = 'sign_date_formatted';

        let newPolisButtons = [...document.getElementsByClassName('newPolis')]
        newPolisButtons.forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault()
                this.toDisplay = true
            });
            item.innerHTML = `<table style="width:100%; height:100%;"><tbody><tr><td>Новая заявка</td></tr></tbody></table>`;
        })
    },
    watch: {
        'pagination.descending': {
            handler() {
                this.paginationHandle();
            }
        },
        'pagination.sortBy': {
            handler() {
                this.paginationHandle();
            }
        },
        'pagination.page': {
            handler() {
                this.paginationHandle();
            }
        },
        'pagination.rowsPerPage': {
            handler() {
                this.paginationHandle();
            }
        },
        'pagination.totalItems': {
            handler() {
                this.paginationHandle();
            }
        },
        'filters.tab': {
            handler() {
                this.paginationHandle();
            }
        },
        'filters.date_from'(newVal) {
        // Если дата "от" установлена и дата "до" меньше новой даты "от" - сбрасываем дату "до"
        if (newVal && this.filters.date_to && newVal > this.filters.date_to) {
            this.filters.date_to = null;
        }
    }
    }
}
</script>

<style scoped>

.date-filter,
.type-filter,
.operator-filter {
    min-width: 200px;
    flex-grow: 1;
}

.operator-filter {
    min-width: 300px;
}

/* Адаптация под разные экраны */
@media (max-width: 1263px) {
    /* При ширине 1024px-1263px */
    .date-filter,
    .type-filter {
        min-width: 180px;
        flex-basis: 25%;
    }

    .operator-filter {
        min-width: 100%;
    }
}

@media (max-width: 1023px) {
    /* При ширине 768px-1023px */
    .date-filter {
        min-width: 50%;
        flex-basis: 100%;
    }
    .type-filter {
        min-width: 100%;
        flex-basis: 100%;
    }
}

@media (max-width: 767px) {
    /* При ширине до 767px */
    .date-filter {
        min-width: 100%;
        flex-basis: 100%;
    }

    .type-filter,
    .operator-filter {
        min-width: 100%;
    }
}

/* Стили для полей ввода */
.date-filter >>> .v-input,
.type-filter >>> .v-input,
.operator-filter >>> .v-input {
    min-width: 100%;
}

/* Улучшения для выпадающих списков */
.type-filter >>> .v-select__selection {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.type-filter >>> .v-menu__content {
    min-width: 250px !important;
}

/* Для очень маленьких экранов */
@media (max-width: 400px) {
    .date-filter {
        flex-basis: 100%;
    }

    .date-filter:first-child {
        margin-bottom: 15px;
    }
}



.links_container {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
/* ssssssssssssss */
.custom-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 15px; /* Добавляем отступы по краям для мобильных */
  box-sizing: border-box;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  position: relative;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 100%; /* Занимает всю доступную ширину */
  max-width: 500px; /* Максимальная ширина для десктопа */
  overflow: hidden;
}

.modal-title {
  padding: 15px 20px; /* Уменьшаем отступы */
  margin: 0;
  background: #f5f5f5;
  font-size: 1.1rem; /* Уменьшаем размер шрифта */
  font-weight: 500;
  border-bottom: 1px solid #eee;
}

.modal-body {
  padding: 15px 20px; /* Уменьшаем отступы */
}

.select-label {
  display: block;
  margin-bottom: 8px; /* Уменьшаем отступ */
  font-weight: 500;
  font-size: 0.9rem; /* Уменьшаем размер шрифта */
}

.custom-select {
  position: relative;
  display: block;
  width: 100%;
}

.status-select {
  width: 100%;
  padding: 10px 15px; /* Уменьшаем отступы */
  font-size: 0.9rem; /* Уменьшаем размер шрифта */
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.select-arrow {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #666;
  font-size: 0.8rem; /* Уменьшаем размер стрелки */
}

.modal-actions {
  display: flex;
  flex-direction: column; /* Меняем направление на вертикальное */
  gap: 10px; /* Добавляем промежуток между кнопками */
  padding: 15px;
  border-top: 1px solid #eee;
  background: #f9f9f9;
}

.modal-btn {
  padding: 12px; /* Увеличиваем для удобства касания */
  margin-left: 0; /* Убираем левый отступ */
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.2s;
  width: 100%; /* Делаем кнопки на всю ширину */
  box-sizing: border-box;
  text-align: center;
}

.cancel-btn {
  background: #f5f5f5;
  color: #333;
}

.cancel-btn:hover {
  background: #e0e0e0;
}

.confirm-btn {
  background: #00ba57;
  color: white;
}

.confirm-btn:hover {
  background: #009c48;
}

/* Медиа-запросы для мобильной адаптации */
@media (max-width: 600px) {
  .modal-content {
    max-width: 100%; /* На мобильных занимает всю ширину */
    border-radius: 0; /* Убираем скругление углов */
  }

  .custom-modal {
    padding: 0; /* Убираем отступы */
    align-items: flex-end; /* Выравниваем по низу */
  }

  .modal-content {
    border-radius: 8px 8px 0 0; /* Скругляем только верхние углы */
  }

  .modal-title {
    font-size: 1rem; /* Еще уменьшаем размер шрифта */
    padding: 12px 15px;
  }

  .modal-body {
    padding: 10px 15px;
  }
}

@media (max-width: 400px) {
  .modal-actions {
    flex-direction: column; /* Гарантируем вертикальное расположение */
  }

  .modal-btn {
    padding: 10px; /* Немного уменьшаем отступы */
  }
}
/* ssssssssssssss */

.activator-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px; /* Расстояние между кнопкой и ссылкой */
    width: 100%;
}

.policy-link {
    text-align: center;
    width: 100%;
    color: #00ba57; /* Цвет как у кнопки */
    font-family: 'SFPro', sans-serif;
    font-size: 16px;
    transition: opacity 0.3s;
}

.policy-link:hover {
    opacity: 0.8;
}

.submit-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 18px !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 56px;
    width: 100%;
    background-color: #00ba57 !important;
    text-align: center;
    vertical-align: middle;
    padding: 0 !important;
    margin: 0;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

.submit-button >>> .v-btn__content {
    white-space: pre-wrap;
    margin: 16px 0 0;
    line-height: 1.1;
}

.preview-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 19px !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 70px;
    width: 90%;
    background-color: #00ba57 !important;
    text-align: center;
    padding: 0 30px !important;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

/deep/ h1 {
    font-size: 65px;
    font-family: 'SFPro';
    line-height: 1.1;
    font-weight: 700;
    color: #000000;
}
@media (max-width: 600px) {
     h1 {
        font-size: 40px;
    }
}

/deep/ h2, h3 {
    font-family: 'SFProBold';
}

/deep/ h2 {
    font-size: 28px;
}

/deep/ h3 {
    font-size: 20px;
}

/deep/ .v-tabs__item {
    justify-content: center;
    text-transform: none;
    font-size: 16px;
    font-weight: 500;
}

/deep/ .v-tabs__item--active {
    font-weight: 700;
}

.agent-actions a {
    color: black;
    margin-right: 40px;
}

.agent-actions a img {
    margin-right: 5px;
    width: 21px;
    height: 21px;
    vertical-align: -5px;
}

.agent-actions a.disabled {
    color: grey;
}

.agent-actions a.disabled img {
    color: grey;
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
}

/* /deep/ .v-menu__content {
    margin-left: 30px;
    margin-top: 80px;
} */

/deep/ table.v-table tbody td,
/deep/ table.v-table tbody th {
    height: 110px;
    text-align: center;
}

/deep/ table.v-table tbody td,
/deep/ table.v-table thead th {
    font-size: 14px;
}

/deep/ table.v-table thead td,
/deep/ table.v-table tbody td,
/deep/ table.v-table thead th,
/deep/ table.v-table tbody th {
    padding: 0 5px;
}

/deep/ table.v-table tbody td {
    cursor: pointer;
}

/deep/ table.v-table thead tr th.sortable {
    white-space: nowrap;
}

.ins-logo-container {
    white-space: wrap !important;
    display:flex !important;
    align-items: center !important;
    justify-content: start !important;
    padding-left: 20px !important;
    /* padding-right: 20px !important; */
}

.ins-logo {
    max-height: 32px;
    width: 100px;
    object-fit: contain;
    vertical-align: start;
    padding-right: 10px !important;
}

.ins-logo-name {
    width: 150px;
    overflow: hidden;
    text-align: start;
    text-overflow: ellipsis;
}

.link {
    font-size: 14px;
    text-decoration: underline;
}

/* /deep/ .filters .v-input__slot,
/deep/ .filters .v-input__control,
/deep/ .filters .v-text-field {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
} */

/deep/ .mh-0-important input {
    min-height: 0 !important;
}

/deep/ .with-count .v-tabs__item {
    position: relative !important;
}

/deep/ .with-count .v-tabs__item .with-count__num {
    position: absolute;
    width: 20px;
    height: 20px;
    right: 0;
    top: 0;
    background-color: #00ba57;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    font-size: 12px;
    transform: translate(5px, 0px);
}

/deep/ tr.not-active {
    background: #eee;
}


/* FIXES FOR TABLE COLUMN WIDTHS */
/deep/ .v-table {
  table-layout: fixed;
}

/deep/ .v-table table {
  width: 100%;
}

/deep/ .v-table thead th {
  overflow: hidden;
  text-overflow: ellipsis;
}

/deep/ .v-table tbody td {
  word-wrap: break-word;
  overflow-wrap: break-word;
  vertical-align: center;
}

.no-wrap {
  white-space: nowrap;
}

.wrap {
  word-break: break-word;
}

/* .ins-logo-container {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 6px;
} */

.clean-filters-field {
    @media(max-width: 600px) {
        order: 1;
    }
}

.status-filter-field {
    @media(max-width: 600px) {
        order: 0;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/bank-products/BankProductsList.vue